import "./datatableSiteLocalName.scss";
import {DataGrid, enUS, GridToolbar} from "@mui/x-data-grid";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import useFetch from "../../hooks/useFetch";
import newRequest from "../../context/newRequest";
import {useDebounce} from "use-debounce";
import axios from "axios";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const DatatableSiteLocalName = ({columns}) => {
    const location = useLocation();
    const path = location.pathname.split("/")[1];
    const [list, setList] = useState([]);
    const { data, loading, error } = useFetch(`/localsite`);
    const [filters, setFilters] = useState({
        popId: "",
        statusSite: "",
        site_name: "",
    });



    const [debounceValue] = useDebounce({ ...filters }, 1000);

    useEffect(() => {
        setList(data);
    }, [data]);

    const [pageState, setPageState] = useState({
        isLoading: false,
        data: [],
        total: 0,
        page: 1,
        pageSize: 10,
    })

    useEffect(() => {
        const fetchData = async () => {
            setPageState(old => ({ ...old, isLoading: true }))
            const response = await newRequest.get(`/localsite?sitename=${filters.site_name}&pop=${filters.popId}&status=${filters.statusSite}&page=${pageState.page}`)
            const json = await response

            setPageState(old => ({ ...old, isLoading: false, data: json.data.data, total: json.data.paging.total_item }))
        }
        fetchData()
    }, [pageState.page, pageState.pageSize,debounceValue])


    const handleInputChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value.toLowerCase() }));
    };
    const handleDelete = async (id, token) => {
        try {
            await axios.delete(`/${path}/${id}` , {
                    headers: {
                        'Authorization': `$Bearer ${token}`
                    }
                }
            );
            const list = pageState.data
            setPageState(old => ({ ...old, isLoading: false, data:list.filter((item) => item.id !== id)  }));
        } catch (err) {}
    };

    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <Link to={`/localsite/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div className="viewButton">View</div>
                        </Link>
                        <Link to={`/localsite/update/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Update Name Local Site
                            </div>
                        </Link>

                        <Link to={`/localsite/open/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Open Ticket Gangguan
                            </div>
                        </Link>
                     {/*   <div
                            className="deleteButton"
                            onClick={() => handleDelete(params.row.id)}
                        >
                            Delete
                        </div>*/}

                    </div>
                );
            },
        },
    ];

    return (
        <div className="datatable">
            <div className="datatableTitle">
                {path.toUpperCase()} Local

            </div>
            <br/>

            <div className="column-search">
                <div className="column-search">
                    {/* popId */}
                    <div className="search">
                        <input
                            type="text"
                            placeholder="popId"
                            value={filters.popId}
                            onChange={(e) => handleInputChange("popId", e.target.value)}
                        />
                        <SearchOutlinedIcon/>
                    </div>

                    {/* site_name */}
                    <div className="search">
                        <input
                            type="text"
                            placeholder="site_name"
                            value={filters.site_name}
                            onChange={(e) => handleInputChange("site_name", e.target.value)}
                        />
                        <SearchOutlinedIcon/>
                    </div>


                </div>

            </div>


            <Link to={`/${path}/new`} className="link">
                Add Local Site Baru
            </Link>

            <br/>
            <br/>

            <DataGrid
                className="datagrid"
                localeText={enUS.components.MuiDataGrid.defaultProps.localeText}
                components={{
                    Toolbar: GridToolbar
                }}
                columns={columns.concat(actionColumn)}
                autoHeight
                rows={pageState.data}
                rowCount={pageState.total}
                loading={pageState.isLoading}
                rowsPerPageOptions={[10, 30, 50, 70, 100]}
                pagination
                page={pageState.page - 1}
                pageSize={pageState.pageSize}
                paginationMode="server"
                onPageChange={(newPage) => {
                    setPageState(old => ({...old, page: newPage + 1}))
                }}
                onPageSizeChange={(newPageSize) => setPageState(old => ({...old, pageSize: newPageSize}))}

            />
        </div>
    );
};

export default DatatableSiteLocalName;

const capitalizePlaceholder = (field) => {
    switch (field) {
        case "popId":
            return "popId";
        case "site_name":
            return "site_name";
        case "status":
            return "Status";
        default:
            return "";
    }
};